import { useStores } from 'Hooks/useStore';
import useTenantScope from 'LearningManager/hooks/useTenantScope';

interface ReportTenant {
	tenantId?: number;
	scopeTenantId?: number;
	isTenantResolved: boolean;
}

const useReportTenantId = (): ReportTenant => {
	const { systemsStore } = useStores();
	const { canSelectTenant, scopedTenant } = useTenantScope();

	if (canSelectTenant) {
		const selected = Number(systemsStore.selectedTenant.value) || undefined;
		return {
			tenantId: selected,
			scopeTenantId: selected,
			isTenantResolved: true
		};
	}

	return {
		tenantId: undefined,
		scopeTenantId: Number(scopedTenant) || undefined,
		isTenantResolved: true
	};
};

export default useReportTenantId;
